import {Onair} from "./onair.ts";
import {DaoApp} from "../daos/dao-app.ts";
import {IDBService} from "./idb.service.ts";
import {IWSService} from "./iws.service.ts";
import {EventBus} from "./event.bus.ts";
import type {BrandBase} from "../brands/brand.base.ts";
import {Brandradio} from "../brands/brandradio.ts";
import {Rhymeduck} from "../brands/rhymeduck.ts";
import {Utils} from "./utils.ts";
import WpiDefault from "./interfaces/wpi.default.ts";
import WpiiOS from "./interfaces/wpi.ios.ts";
import type WpiBase from "./interfaces/wpi.base.ts";
import {format} from "date-fns";
import _ from "lodash";

function brandConfig(): BrandBase {
  const hostname: string = location.hostname;
  if(hostname.indexOf("rhymeduck.") > -1) return new Rhymeduck();
  else if (hostname.indexOf("brandradio.") > -1) return new Brandradio();
  else return new Brandradio();
}

function wpiCallback(): WpiBase {
  const os = Utils.osname();
  switch (os) {
    case "Android":
    case "WindowsApp":
    case "MacintoshApp":
      return window.wpi ? window.wpi : new WpiDefault();
    case "iOS":
    case "macOS":
      return new WpiiOS();
    case "Windows 10":
    case "Windows 8":
    case "Windows 8.1":
    case "Windows 7":
    case "Windows Vista":
    case "Windows XP":
    case "Windows 2000":
    case "Windows":
      // window.external 이 WpiBase 인지 여부에 따라 조건 분기
      const wpi_base: WpiBase = window.external as unknown as WpiBase;
      let externals: boolean = false;
      try {
        externals = typeof wpi_base === 'object' && wpi_base !== null && typeof wpi_base.version === 'function';
      } catch (e) {
        externals = false;
      }
      return externals ? wpi_base : new WpiDefault();
    case "Linux":
    default:
      return new WpiDefault();
  }
}

export const app = new DaoApp(brandConfig());

export const onair = new Onair();

export const idba = new IDBService(app.package);

export const iws = new IWSService();

export const events = new EventBus();

export const wpi: WpiBase = wpiCallback();

export const use_mp3: boolean = true;

export const EventType = {
  NETWORK_CHANGE: "network_change"
}

export type NetState = 'NO_NETWORK' | 'NO_INTERNET' | 'OK' | 'SLOW';
export type NetTransport = 'WIFI' | 'CELLULAR' | 'ETHERNET' | 'VPN' | 'OTHER' | 'UNKNOWN';

export interface NetResult {
  state: NetState;
  transport: NetTransport;
  rttMs?: number;
  detail?: string;
  ts?: number; // native에서 넣어주면 좋음
}

export const callCustomerCenter = function () {
  if(Utils.isMobileOrTableDevice()) {
    window.location.href = `tel:${app.csphone}`;
  } else {
    try {
      const win = window.open(app.cscenter, "_blank");
      if (!win) window.location.href = `tel:${app.csphone}`;
    } catch(e) {
      void e;
    }
  }
};

export const throwError = (message: string): void => {
  throw new Error(message);
};

export const print = (...args: any[] | any): void => {
  const isDev = _.some(['localhost', '10.4.17.42', 'wp-dev'], kw => _.includes(_.toLower(location.hostname), kw));
  if(isDev || app.isDebug) {
    args = [format(Utils.now(), "MM.dd HH:mm:ss"), ...args];
    console.log(...args);
  }
}